'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Upload = require('./Upload');

var _Upload2 = _interopRequireDefault(_Upload);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _Upload2['default']; // export this package's api

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/rc-upload/lib/index.js
// module id = 1565
// module chunks = 0